import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TradingAccountCard.css';

const TradingAccountCard = ({ account, index }) => {
  const [isCopied, setIsCopied] = useState(false);
  const navigate = useNavigate();

  // Функция для форматирования суммы
  const formatBalance = (amount) => {
    return new Intl.NumberFormat('ru-RU').format(amount);
  };

  // Функция для получения класса иконки в зависимости от валюты
  const getCurrencyIconClass = (currency) => {
    const currencyMap = {
      'RUB': 'trading-account-card__main--icon-rub',
      'USD': 'trading-account-card__main--icon-usd',
      'EUR': 'trading-account-card__main--icon-eur',
      'CNY': 'trading-account-card__main--icon-cny'
    };
    return currencyMap[currency] || 'trading-account-card__main--icon-usd'; // По умолчанию доллар
  };

  // Функция для получения цвета результата в зависимости от прибыли
  const getResultClass = (profit) => {
    if (profit > 0) return 'count__result--income';
    if (profit < 0) return 'count__result--withdraw';
    return '';
  };

  // Функция для копирования номера счета в буфер обмена
  const handleCopyAccountNumber = async () => {
    try {
      await navigator.clipboard.writeText(account.account_number);
      setIsCopied(true);
      // Сбрасываем состояние через 2 секунды
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Ошибка при копировании номера счета:', err);
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = account.account_number;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    }
  };

  return (
    <div data-fls-block="" className="trading-account-card count">
      {/* <div className={`trading-account-card__main count__main ${getCurrencyIconClass(account.currency)}`}>
        <div className="trading-account-card__content count__content">
          <div className="trading-account-card__header">
            <h5 className="trading-account-card__title count__title count__title--title-20">
              Торговый счет #{index + 1}
            </h5>
          </div>
        </div>
      </div> */}
      
      <div className="trading-account-card__table">
        <div className="trading-account-card__column">
        <div className={`trading-account-card__main count__main ${getCurrencyIconClass(account.currency)}`}></div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}><h5 className="trading-account-card__title count__title count__title--title-20">
              Номер счета
          </h5>
          <div className="trading-account-card__code count__code">
            <span>{account.account_number}</span>
            <button 
              type="button" 
              className={`trading-account-card__copy count__copy count__copy--icon-copy ${isCopied ? 'copied' : ''}`}
              onClick={handleCopyAccountNumber}
              title={isCopied ? "Скопировано!" : "Копировать номер счета"}
            >
              {isCopied && <span className="copy-feedback">✓</span>}
            </button>
          </div></div>
          
        </div>
        
        <div className="trading-account-card__columns-wrapper">
          <div className="trading-account-card__column">
            <div className="trading-account-card__subtitle count__subttile">
              Депозит
            </div>
            <div className="trading-account-card__result count__result">
              <div className="trading-account-card__span count__span count__span--title-20" style={{ fontWeight: '600', color: '#26A435', fontSize: '1.4rem' }}>
                <span>{formatBalance(account.deposit_amount || 0)} {account.currency}</span>
              </div>
            </div>
          </div>
          
          <div className="trading-account-card__column trading-account-card__column--profit">
            <div className="trading-account-card__subtitle count__subttile ots">
              Доход {account.date}
            </div>
            <div className={`trading-account-card__result count__result ${getResultClass(account.profit)}`}>
              <div className="trading-account-card__result-content">
                <div className="trading-account-card__span count__span count__span--title-20" style={{ fontWeight: '600', color: '#26A435', fontSize: '1.4rem'  }}>
                  <span>{formatBalance(account.profit || 0)} {account.currency}</span>
                </div>
                <div className="trading-account-card__span count__span count__span--title-20 marg" style={{ fontWeight: '600', color: '#26A435', fontSize: '1.4rem'  }}>
                  <span>{account.percentage || 0}%</span>
                </div>
              </div>
              <button 
                className="trading-account-card__details-btn"
                onClick={() => navigate('/account/history?tab=profits')}
              >
                Подробнее
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingAccountCard;